import { render } from "./About.vue?vue&type=template&id=20c93187"
const script = {}

import "./About.vue?vue&type=style&index=0&id=20c93187&lang=scss"
script.render = render

export default script